import { __assign } from "tslib";
import React from 'react';
import { Button as sdkButton, chatSdk, Constants, } from '@wix/chat-sdk';
import classNames from 'classnames';
import withTheme from '../../../providers/theme/withTheme';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styles from './StandardTemplateV2Bubble.scss';
import withAppMode from '../../../providers/appMode/withAppMode';
import { AppMode } from '../../../constants/app-mode';
import { ButtonType } from '@wix/ambassador-serverless-chat-platform/types';
import { Experiments } from '../../../constants/experiments';
import { MessageOrientation } from '../../../types/InputKeyboards';
import { ReactComponent as ChevronRight } from '../../../assets/svg-icons/chevronRight.svg';
var MessageBorderRadius;
(function (MessageBorderRadius) {
    MessageBorderRadius[MessageBorderRadius["Small"] = 0] = "Small";
    MessageBorderRadius[MessageBorderRadius["Medium"] = 12] = "Medium";
    MessageBorderRadius[MessageBorderRadius["Large"] = 20] = "Large";
})(MessageBorderRadius || (MessageBorderRadius = {}));
var ButtonBorderRadius;
(function (ButtonBorderRadius) {
    ButtonBorderRadius[ButtonBorderRadius["Small"] = 0] = "Small";
    ButtonBorderRadius[ButtonBorderRadius["Medium"] = 4] = "Medium";
    ButtonBorderRadius[ButtonBorderRadius["Large"] = 20] = "Large";
})(ButtonBorderRadius || (ButtonBorderRadius = {}));
var ButtonPadding;
(function (ButtonPadding) {
    ButtonPadding[ButtonPadding["Landscape"] = 12] = "Landscape";
    ButtonPadding[ButtonPadding["Portrait"] = 16] = "Portrait";
})(ButtonPadding || (ButtonPadding = {}));
var StandardTemplateV2Bubble = function (_a) {
    var _b, _c, _d;
    var _e;
    var message = _a.message, theme = _a.theme, appMode = _a.appMode, eventHooks = _a.eventHooks, onButtonInteraction = _a.onButtonInteraction;
    var _f = message.templateData, image = _f.image, icon = _f.icon, title = _f.title, text = _f.text, lines = _f.lines, buttons = _f.buttons, orientation = _f.orientation;
    var isFullApp = appMode === AppMode.FullApp;
    var fontFamily = _get(theme, 'room.fontFamily');
    var isEnableChatNewUI = chatSdk.isExperimentOn(Experiments.EnableChatNewUI);
    var isAddActionColorSettingEnabled = chatSdk.isExperimentOn(Experiments.AddActionColorSetting);
    var sendIconColor = _get(theme, 'input.sendIconColor');
    var messageBorderRadius = (_e = _get(theme, 'room.message.borderRadius')) !== null && _e !== void 0 ? _e : 0;
    var actionButtonTextColor = _get(theme, 'room.message.actionColor', sendIconColor);
    var iconUrl = _get(theme, ['room', 'icons', icon]);
    var imageIcon = iconUrl || image;
    var handleButtonClick = function (button) {
        if (button.payload && onButtonInteraction && !isFullApp) {
            onButtonInteraction && onButtonInteraction(sdkButton.buildButton(button));
        }
        if (button.cta && eventHooks.onCallToActionClick) {
            eventHooks.onCallToActionClick(button.cta);
        }
    };
    var linesComp = lines &&
        lines.map(function (line, index) { return (React.createElement("div", { className: styles.standardTemplateV2Line, "data-hook": "standard-template-v2-line", style: { fontFamily: fontFamily }, key: index }, line)); });
    var hasText = !_isEmpty(lines) || title || text;
    var getButtonsBackwardCompatibility = function () {
        // Here I access dto which is private only to fix a data structure mistake.
        return (message.dto.data &&
            message.dto.data
                .filter(function (dataItem) { return dataItem.mimeType === 'button'; })
                .map(function (dtoData) { return dtoData.data; }));
    };
    function getButtonsIncludingBackwardCompatibility() {
        return _isEmpty(buttons) ? getButtonsBackwardCompatibility() : buttons;
    }
    var renderButtons = function () {
        var _a;
        var buttonsIncludingBackwardCompatibility = getButtonsIncludingBackwardCompatibility();
        return (buttonsIncludingBackwardCompatibility && (React.createElement("div", { className: classNames((_a = {},
                _a[styles.landscapeButtons] = landscapeLayoutEnabled,
                _a[styles.buttons] = true,
                _a)) }, buttonsIncludingBackwardCompatibility.map(function (button, index) {
            var _a;
            return (React.createElement("button", { "data-hook": "standard-template-v2-button", style: {
                    color: isFullApp
                        ? undefined
                        : isAddActionColorSettingEnabled
                            ? actionButtonTextColor
                            : sendIconColor,
                }, className: classNames((_a = {},
                    _a[styles.button] = true,
                    _a[styles.disabled] = isFullApp && button.type === ButtonType.POSTBACK,
                    _a)), key: index, onClick: function () { return handleButtonClick(button); }, disabled: isFullApp && button.type === ButtonType.POSTBACK }, button.text));
        }))));
    };
    var landscapeLayoutEnabled = orientation === Constants.MessageOrientation.Landscape && isEnableChatNewUI;
    var mapMessageBorderRadiusToButtonBorderRadius = function (radius) {
        switch (radius) {
            case MessageBorderRadius.Large:
                return ButtonBorderRadius.Large;
            case MessageBorderRadius.Medium:
                return ButtonBorderRadius.Medium;
            case MessageBorderRadius.Small:
                return ButtonBorderRadius.Small;
            default:
                return ButtonBorderRadius.Medium;
        }
    };
    var renderButtonsV2 = function () {
        var buttonsIncludingBackwardCompatibility = _isEmpty(buttons)
            ? getButtonsBackwardCompatibility()
            : buttons;
        var buttonColor = isAddActionColorSettingEnabled
            ? actionButtonTextColor
            : sendIconColor;
        var buttonsPaddingDependingOnOrientation = orientation === MessageOrientation.Landscape
            ? ButtonPadding.Landscape
            : ButtonPadding.Portrait;
        return (buttonsIncludingBackwardCompatibility && (React.createElement("div", { className: styles.buttonsV2, style: {
                padding: "0 " + buttonsPaddingDependingOnOrientation + "px " + buttonsPaddingDependingOnOrientation + "px " + buttonsPaddingDependingOnOrientation + "px",
            } }, buttonsIncludingBackwardCompatibility.map(function (button, index) {
            var _a;
            return (React.createElement("button", { "data-hook": "standard-template-v2-button", style: {
                    color: isFullApp ? undefined : buttonColor,
                    borderColor: isFullApp ? undefined : buttonColor,
                    borderRadius: isFullApp
                        ? undefined
                        : mapMessageBorderRadiusToButtonBorderRadius(messageBorderRadius),
                }, className: classNames((_a = {},
                    _a[styles.button] = true,
                    _a[styles.disabled] = isFullApp && button.type === ButtonType.POSTBACK,
                    _a)), key: index, onClick: function () { return handleButtonClick(button); }, disabled: isFullApp && button.type === ButtonType.POSTBACK }, button.text));
        }))));
    };
    var handleBubbleClick = function (e) {
        if (shouldHideStandardButtons) {
            e.stopPropagation();
            handleButtonClick(buttonsIncludingBackwardCompatibility[0]);
        }
    };
    var buttonsIncludingBackwardCompatibility = getButtonsIncludingBackwardCompatibility();
    // show standard buttons only if there are more than one button
    // if there is a single action button and in landscape mode show button as an arrow
    // More details: https://docs.google.com/presentation/d/1zApePkaMgEb3y0ul6C2vD11uB31nih8sSjx3KPw7wlc/edit#slide=id.g25c94fe2709_0_124
    var shouldHideStandardButtons = (buttonsIncludingBackwardCompatibility === null || buttonsIncludingBackwardCompatibility === void 0 ? void 0 : buttonsIncludingBackwardCompatibility.length) === 1 &&
        landscapeLayoutEnabled;
    return (React.createElement("div", __assign({ "data-hook": "standard-template-v2-wrapper", className: classNames((_b = {},
            _b[styles.standardTemplateV2] = true,
            _b[styles[appMode]] = styles[appMode],
            _b[styles.withStaticBg] = !isEnableChatNewUI,
            _b[styles.bubbleWrapperLandscape] = landscapeLayoutEnabled,
            _b[styles.pointer] = landscapeLayoutEnabled && shouldHideStandardButtons,
            _b)) }, (shouldHideStandardButtons
        ? { onClick: handleBubbleClick, role: 'button' }
        : {})),
        imageIcon && (React.createElement("img", { alt: "bubble", className: classNames((_c = {},
                _c[styles.image] = true,
                _c[styles.landscapeImage] = landscapeLayoutEnabled,
                _c)), "data-hook": "standard-template-v2-image", src: imageIcon })),
        hasText && (React.createElement("div", { "data-hook": "standard-template-v2-text-container", className: classNames((_d = {},
                _d[styles.textsContainer] = true,
                _d[styles.withStaticColor] = !isEnableChatNewUI,
                _d[styles.landscapeDescription] = landscapeLayoutEnabled,
                _d)) },
            title && (React.createElement("div", { "data-hook": "standard-template-v2-title", className: styles.standardTemplateV2Title, style: { fontFamily: fontFamily } }, title)),
            text && (React.createElement("div", { "data-hook": "standard-template-v2-text", className: styles.standardTemplateV2Text, style: { fontFamily: fontFamily } }, text)),
            linesComp)),
        isEnableChatNewUI &&
            shouldHideStandardButtons &&
            appMode === AppMode.Widget ? (React.createElement(ChevronRight, { "data-hook": "right-chevron-icon", color: "inherit", className: styles.arrowButtonIcon })) : null,
        !shouldHideStandardButtons
            ? isEnableChatNewUI && appMode === AppMode.Widget
                ? renderButtonsV2()
                : renderButtons()
            : null));
};
export default withTheme(withAppMode(StandardTemplateV2Bubble));
//# sourceMappingURL=StandardTemplateV2Bubble.js.map